"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint import/no-unresolved: 0 */

/* eslint import/extensions: 0 */

/* eslint global-require: 0 */

var LayerManager =
/*#__PURE__*/
function () {
  // Constructor
  function LayerManager(map) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LayerManager);

    this.map = map;
    this.mapLayers = {};
    this.layersLoading = {};
    this.rejectLayersLoading = false;
    this.onLayerAddedSuccess = options.onLayerAddedSuccess;
    this.onLayerAddedError = options.onLayerAddedError;
  }
  /*
    Public methods
  */


  _createClass(LayerManager, [{
    key: "addLayer",
    value: function addLayer(layer) {
      var _this = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var method = {
        // legacy/deprecated
        leaflet: this.addLeafletLayer,
        arcgis: this.addEsriLayer,
        // carto
        cartodb: this.addCartoLayer,
        carto: this.addCartoLayer,
        // wms
        wmsservice: this.addLeafletLayer,
        wms: this.addLeafletLayer,
        // arcgis
        featureservice: this.addEsriLayer,
        mapservice: this.addEsriLayer,
        tileservice: this.addEsriLayer,
        esrifeatureservice: this.addEsriLayer,
        esrimapservice: this.addEsriLayer,
        esritileservice: this.addEsriLayer,
        // geojson
        geojson: this.addGeoJsonLayer,
        // GEE
        gee: this.addGeeLayer,
        nexgddp: this.addNexGDDPLayer
      }[layer.provider];
      if (method) method.call(this, layer, opts);
      this.execCallback().then(function () {
        if (_this.onLayerAddedSuccess) _this.onLayerAddedSuccess();
      })["catch"](function () {
        _this.layersLoading = {};
        _this.rejectLayersLoading = false;
        if (_this.onLayerAddedError) _this.onLayerAddedError();
      });
    }
  }, {
    key: "removeLayer",
    value: function removeLayer(layerId) {
      if (this.mapLayers[layerId]) {
        this.map.removeLayer(this.mapLayers[layerId]);
        delete this.mapLayers[layerId];
      }
    }
  }, {
    key: "removeLayers",
    value: function removeLayers() {
      var _this2 = this;

      Object.keys(this.mapLayers).forEach(function (id) {
        if (_this2.mapLayers[id]) {
          _this2.map.removeLayer(_this2.mapLayers[id]);

          delete _this2.mapLayers[id];
        }
      });
      this.layersLoading = {};
    }
    /*
      Private methods
    */

  }, {
    key: "execCallback",
    value: function execCallback() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var loop = function loop() {
          if (!Object.keys(_this3.layersLoading).length) return resolve();
          if (_this3.rejectLayersLoading) return reject();
          return setTimeout(loop);
        };

        return setTimeout(loop);
      });
    }
  }, {
    key: "addNexGDDPLayer",
    value: function addNexGDDPLayer(layerData) {
      var tileUrl = "https://api.resourcewatch.org/v1/layer/".concat(layerData.id, "/tile/nexgddp/{z}/{x}/{y}");
      var tileLayer = L.tileLayer(tileUrl).addTo(this.map);
      this.mapLayers[layerData.id] = tileLayer;
    }
  }, {
    key: "addGeeLayer",
    value: function addGeeLayer(layerData) {
      var tileUrl = "https://api.resourcewatch.org/v1/layer/".concat(layerData.id, "/tile/gee/{z}/{x}/{y}");
      var tileLayer = L.tileLayer(tileUrl).addTo(this.map);
      this.mapLayers[layerData.id] = tileLayer;
    }
  }, {
    key: "addGeoJsonLayer",
    value: function addGeoJsonLayer(layer) {
      var geojsonLayer = L.geoJSON(layer.layerConfig.data).addTo(this.map);
      this.mapLayers[layer.id] = geojsonLayer;

      if (layer.layerConfig.fitBounds) {
        var bounds = geojsonLayer.getBounds();
        this.map.fitBounds([bounds.getNorthWest(), bounds.getSouthEast()], {
          padding: [20, 20]
        });
      }
    }
  }, {
    key: "addLeafletLayer",
    value: function addLeafletLayer(layerSpec, _ref) {
      var _this4 = this;

      var zIndex = _ref.zIndex;
      var layerData = layerSpec.layerConfig;
      var layer;
      layerData.id = layerSpec.id;
      this.layersLoading[layerData.id] = true; // Transforming data layer
      // TODO: improve this

      if (layerData.body.crs && L.CRS[layerData.body.crs]) {
        layerData.body.crs = L.CRS[layerData.body.crs.replace(":", "")];
        layerData.body.pane = "tilePane";
      }

      switch (layerData.type) {
        case "wms":
          layer = L.tileLayer.wms(layerData.url, layerData.body); // eslint-disable-line

          break;

        case "tileLayer":
          if (layerData.body.style && typeof layerData.body.style === "string" && layerData.body.indexOf('style: "function') >= 0) {
            layerData.body.style = eval("(".concat(layerData.body.style, ")")); // eslint-disable-line
          }

          layer = L.tileLayer(layerData.url, layerData.body); // eslint-disable-line

          break;

        default:
          delete this.layersLoading[layerData.id];
          throw new Error('"type" specified in layer spec doesn`t exist');
      }

      if (layer) {
        var eventName = layerData.type === "wms" || layerData.type === "tileLayer" ? "tileload" : "load";
        layer.on(eventName, function () {
          delete _this4.layersLoading[layerData.id];
        });

        if (zIndex) {
          layer.setZIndex(zIndex);
        }

        layer.addTo(this.map);
        this.mapLayers[layerData.id] = layer;
      }
    }
  }, {
    key: "addEsriLayer",
    value: function addEsriLayer(layerSpec, _ref2) {
      var _this5 = this;

      var zIndex = _ref2.zIndex;
      var layer = layerSpec.layerConfig;
      var layerData = layerSpec.layerConfig;
      layer.id = layerSpec.id;
      this.layersLoading[layer.id] = true; // Transforming layer
      // TODO: change this please @ra

      var bodyStringified = JSON.stringify(layer.body || {}).replace(/"mosaic-rule":/g, '"mosaicRule":').replace(/"use-cors"/g, '"useCors"'); // first, we check if layer exist in leaflet

      if (L[layer.type]) {
        if (layerData.body.style && typeof layerData.body.style === "string" && layerData.body.indexOf('style: "function') >= 0) {
          layerData.body.style = eval("(".concat(layerData.body.style, ")")); // eslint-disable-line
        }

        var newLayer = new L.tileLayer(layerData.url, layerData.body); // eslint-disable-line

        var layerElement;
        newLayer.on("load", function () {
          delete _this5.layersLoading[layer.id];
          layerElement = _this5.map.getPane("tilePane").lastChild;

          if (zIndex) {
            layerElement.style.zIndex = zIndex;
          }

          layerElement.id = layer.id;
        });
        newLayer.addTo(this.map); // This method is called in setZIndex

        newLayer.setZIndex = function (index) {
          layerElement.style.zIndex = index;
        };

        this.mapLayers[layer.id] = newLayer;
      } else if (L.esri[layer.type]) {
        var layerConfig = JSON.parse(bodyStringified);
        layerConfig.pane = "tilePane";

        if (layerConfig.style && layerConfig.style.indexOf("function") >= 0) {
          layerConfig.style = eval("(".concat(layerConfig.style, ")")); // eslint-disable-line
        }

        var _newLayer = L.esri[layer.type](layerConfig);

        var _layerElement;

        _newLayer.on("load", function () {
          delete _this5.layersLoading[layer.id];
          _layerElement = _this5.map.getPane("tilePane").lastChild;

          if (zIndex) {
            _layerElement.style.zIndex = zIndex;
          }

          _layerElement.id = layer.id;
        });

        _newLayer.addTo(this.map); // This method is called in setZIndex


        _newLayer.setZIndex = function (index) {
          _layerElement.style.zIndex = index;
        };

        this.mapLayers[layer.id] = _newLayer;
      } else {
        this.rejectLayersLoading = true;
        throw new Error('"type" specified in layer spec doesn`t exist');
      }
    }
  }, {
    key: "addCartoLayer",
    value: function addCartoLayer(layerSpec) {
      var _this6 = this;

      var layer = Object.assign({}, layerSpec.layerConfig, {
        id: layerSpec.id,
        order: layerSpec.order,
        opacity: layerSpec.opacity,
        hidden: layerSpec.hidden
      });
      this.layersLoading[layer.id] = true;
      var layerTpl = {
        version: "1.3.0",
        stat_tag: "API",
        layers: layer.body.layers
      };
      var params = "?stat_tag=API&config=".concat(encodeURIComponent(JSON.stringify(layerTpl)));
      fetch("https://".concat(layer.account, ".carto.com/api/v1/map").concat(params)).then(function (response) {
        if (response.status >= 400) {
          _this6.rejectLayersLoading = true;
          throw new Error(response.statusText);
        }

        return response.json();
      }).then(function (data) {
        // const tileUrl = `https://${layer.account}.carto.com/api/v1/map/${data.layergroupid}/{z}/{x}/{y}.png`;
        var tileUrl = "".concat(data.cdn_url.templates.https.url, "/").concat(layer.account, "/api/v1/map/").concat(data.layergroupid, "/{z}/{x}/{y}.png");
        _this6.mapLayers[layer.id] = L.tileLayer(tileUrl).addTo(_this6.map);

        _this6.mapLayers[layer.id].setZIndex(layer.hidden ? -1 : layer.order);

        _this6.mapLayers[layer.id].setOpacity(layer.opacity !== undefined ? layer.opacity : 1);

        _this6.mapLayers[layer.id].on("load", function () {
          delete _this6.layersLoading[layer.id];
        });

        _this6.mapLayers[layer.id].on("tileerror", function () {
          _this6.rejectLayersLoading = true;
        });
      });
    }
  }, {
    key: "setZIndex",
    value: function setZIndex(layers) {
      var _this7 = this;

      var layerIds = Object.keys(this.mapLayers);
      layerIds.forEach(function (layerId) {
        var order = layers.find(function (l) {
          return l.id === layerId;
        }).order;

        _this7.mapLayers[layerId].setZIndex(order);
      });
    }
  }, {
    key: "setOpacity",
    value: function setOpacity(layers) {
      var _this8 = this;

      var layerIds = Object.keys(this.mapLayers);
      layerIds.forEach(function (layerId) {
        var layer = layers.find(function (l) {
          return l.id === layerId;
        });
        var opacity = layer && layer.opacity !== undefined ? layer.opacity : 1;

        _this8.mapLayers[layerId].setOpacity(opacity);
      });
    }
  }]);

  return LayerManager;
}();

exports["default"] = LayerManager;